import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=7a390f22&"
import script from "./DocumentsTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports